import {
  notifyForDailyTimeQuotaReachedIfNeeded,
  shouldShowTimeQuotaNotifications,
} from '../notifications/timesUpNotifications';
import { getDeviceAndUserStore } from '../storage/stores';
import { isOverDailyQuota } from '../validators/timeQuotaValidator';
import { now } from '../lib/dateTime';
import { updateTabsStateIfNeeded } from '../chrome/tabManager';

// Module-level state tracking
let wasQuotaExceeded = false;

/**
 * Called when the consumed quota is updated either by local screen time counting or backend updates.
 * Now handles both quota checking and notifications in one place.
 */
export const onConsumedQuotaUpdated = async () => {
  // Check quota state changes
  const deviceUser = getDeviceAndUserStore().get();
  const currentTime = await now();

  const isQuotaExceeded =
    deviceUser && isOverDailyQuota(deviceUser, currentTime);

  // Check if quota state has changed from not exceeded to exceeded
  if (isQuotaExceeded && !wasQuotaExceeded) {
    console.log('Quota exceeded, triggering actions');
    // Refresh tabs since quota is exceeded
    await updateTabsStateIfNeeded('daily-quota-exceeded');
  }

  // Update the tracking variable
  wasQuotaExceeded = !!isQuotaExceeded;

  // Handle notifications
  if (shouldShowTimeQuotaNotifications()) {
    return notifyForDailyTimeQuotaReachedIfNeeded();
  }
};

/**
 * Called when a new day starts. It will reset the daily quota state and refresh the tabs since previously blocked content may now be accessible.
 */
export const onNewDay = (): void => {
  wasQuotaExceeded = false;
  updateTabsStateIfNeeded('new-day');
};
